/**
 * Раздел «Вопросы» вкладки «Продажи» (#843, #2060): охват, вопросы без
 * ответа — первыми, на «Продажах» это действие для команды, — затем частые
 * вопросы по предмету. Спеки: docs/plans/2026-10-02-customer-questions-and-decline-reasons.md §4,
 * docs/plans/2026-10-11-voice-report-layers.md §2.2.
 *
 * Знаменатель называется до числителей: строка охвата («собрано в X из Y,
 * не собрано Z») и «данные с <даты>» стоят над блоками.
 */
import { useTranslation } from 'react-i18next';
import type { VoiceCustomerQuestions } from '@aica/api-types/schemas';
import { VoiceQuestionPanel } from './VoiceQuestionPanel';
import { VoiceQuestionsCoverage } from './VoiceQuestionsCoverage';
import { VoiceQuestionsNotes } from './VoiceQuestionsNotes';
import { VOICE_TOP_ROWS } from './VoiceTopList';
import {
  questionSection,
  salesQuestionsDenominatorNote,
  unansweredSection,
} from './voice-questions-view-model';
import type { VoiceSearch } from './voice-search';

interface VoiceSalesQuestionsProps {
  cq: VoiceCustomerQuestions;
  search: VoiceSearch;
  onSearchChange: (patch: Partial<VoiceSearch>) => void;
  onOpenCall: (recordId: string) => void;
}

export function VoiceSalesQuestions({
  cq,
  search,
  onSearchChange,
  onOpenCall,
}: VoiceSalesQuestionsProps) {
  const { t } = useTranslation('dashboard');
  const panel = { cq, search, onSearchChange, onOpenCall, limit: VOICE_TOP_ROWS };
  return (
    <div className="space-y-4">
      <VoiceQuestionsCoverage cq={cq} />
      <VoiceQuestionPanel
        {...panel}
        section={unansweredSection(cq)}
        hint={t('voicePage.questions.unansweredHint')}
      />
      <VoiceQuestionPanel {...panel} section={questionSection(cq)} />
      <VoiceQuestionsNotes cq={cq}>
        <p>{t(salesQuestionsDenominatorNote)}</p>
      </VoiceQuestionsNotes>
    </div>
  );
}
